import { GViewInfo } from 'api';
import {
    initCookieConsent,
    InitPotreeTemplate,
    potreeRenderPreparations,
} from 'utils';

interface HandleSuccessGviewResult {
    permissions: Record<any, any>;
}

export function handleSuccessGview(data: GViewInfo): HandleSuccessGviewResult {
    initCookieConsent();
    potreeRenderPreparations(data);
    const args = {
        prj_id: data.prj_id,
        prj_name: data.prj_name,
        prj_token: data.prj_token,
        prj_storg_name: data.prj_storg_name,
        prj_path: data.prj_path,
        dataset_id: data.dataset_id,
        snapshot_id: data.snapshot_id,
        user_id: data.user_id,
        permission: data.permission,
        org_id: data.org_id,
        team_id: data.team_id,
        org_style: data.org_style,
        org_name: data.org_name,
        org_website: data.org_website,
        copyright_date: new Date().getFullYear(),
        watermark: data.watermark,
        watermark_text: data.watermark_text,
        enable_orthofile: data.enable_orthofile,
    };

    ChangeFavIcon(data.org_id);

    const defMenuMainColor = '#bfd730';
    const defMenuLightColor = '#aec523';
    const defMenuTextColor = 'gray';
    const defMenuSidbarBGColor = 'rgba(77,78,80,1)';

    if (data.org_style) {
        var orgAppearance = JSON.parse(data.org_style);
        //var orgAppearance = JSON.parse(`{"style":{"color":{"menu_text":"#fff","menu_main":"#00ceba", "menu_light":"#00bca9", "dark":"#00796b", "dark":"#00796b", "dark":"#00796b", "dark":"#00796b","main":"#009688","name":"tifany","light":"#4db6ac","exLight":"#b2dfdb","buttonText":"#fff","contrastText":"rgba(255,255,255, 1)"}},"company_name":"DENADA. CO11111","logo":true,"background":true}`);
        var orgColor = orgAppearance ? orgAppearance.color : null;
        document.documentElement.style.setProperty(
            '--main-color',
            orgColor.menu_main ? orgColor.menu_main : defMenuMainColor
        );
        document.documentElement.style.setProperty(
            '--light-color',
            orgColor.menu_light ? orgColor.menu_light : defMenuLightColor
        );
        document.documentElement.style.setProperty(
            '--text-color',
            orgColor.menu_text ? orgColor.menu_text : defMenuTextColor
        );
        document.documentElement.style.setProperty(
            '--sidbar-bg-color',
            orgColor.sidbar_menu_bg
                ? orgColor.sidbar_menu_bg
                : defMenuSidbarBGColor
        );
    } else {
        document.documentElement.style.setProperty(
            '--main-color',
            defMenuMainColor
        );
        document.documentElement.style.setProperty(
            '--light-color',
            defMenuLightColor
        );
        document.documentElement.style.setProperty(
            '--text-color',
            defMenuTextColor
        );
        document.documentElement.style.setProperty(
            '--sidbar-bg-color',
            defMenuSidbarBGColor
        );
    }

    const { permissions } = InitPotreeTemplate(args as any);

    return { permissions };
}

/*[CHANGE FAVICON IN ENTERPRISE]*/
function ChangeFavIcon(orgId: string) {
    var orginUrl = window.location.origin;
    var link = (document.querySelector("link[rel*='icon']") ||
        document.createElement('link')) as HTMLLinkElement;
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    if (orgId) {
        link.href = orginUrl + '/psp/dl/org/glb/logo' + '?' + Date.now();
    } else {
        link.href = orginUrl + '/psp/vl/potree/resources/icons/favicon.ico';
    }
    document.getElementsByTagName('head')[0].appendChild(link);
}
